<template>
  <Modal v-model="isShow"
         :width="500"
         :mask-closable="false"
         :loading="loading"
         @on-ok="save"
         @on-cancel="cancel"
  >
    <h3>发放资产</h3>
        <Form ref="form" :rules="formRules" :model="formData" style="margin-top:24px" :label-width="100" >
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="资产编号" prop="assetsCode">-->
<!--                <Input style="width:200px" v-model="formData.assetsCode" @on-blur="findAssets" />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row>
            <FormItem label="资产编码" prop="assetsCode">
              <Select
                  v-model="formData.assetsCode"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="请输入想查询的资产编号"
                  style="width:200px" @on-change="findAssets">
                <Option v-for="item in assetsCodeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产名称" prop="assetsName">
                <input style="width:200px" v-model="formData.assetsName" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="发放资产总数" prop="assetsNumber">
                <input style="width:200px" v-model="formData.assetsNumber" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="领用人" prop="receivePersonName">-->
<!--                <input style="width:200px" v-model="formData.receivePersonName" class="input-long ivu-input" />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row>
            <FormItem label="领用人" prop="receivePersonName">
              <Select
                  v-model="formData.receivePersonName"
                  filterable
                  remote
                  :remote-method="remoteFindPersonMethod"
                  :loading="loading"
                  placeholder="请输入姓名"
                  style="width:200px">
                <Option v-for="item in receivePersonNameList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="发放资产备注" prop="remark">
                <input style="width:200px" v-model="formData.remark" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
        </Form>
  </Modal>
</template>

<script>
import {getAssetsByAccetsCode, getLikeCodeByAccetsCode, provideAssets, getPersonNameByName} from "api/assets";
import {formatDateTime} from "utils/format";

export default {
  watch:{
    n(val){
      this.loading=true,
      this.isShow = true,
      this.$refs['form'].resetFields();
    },
  },
  props: {
    // sizeFid:{
    //   default:null
    // },
    // assetsFid:{
    //   default:null
    // },
    n:{
      default:0
    }
  },
  data() {
    return {
      loading:true,
      isShow:false,
      type: 'polygon',
      assetsCodeList:[],
      receivePersonNameList:[],
      formData: {
        assetsNumber:'',
        receivePersonName:'',
        remark:'',
        assetsCode:'',
        assetsName:'',
      },
      formRules:{
        assetsCode:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        assetsName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        receivePersonName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        assetsNumber:[{ required: true, message: '请输入数字' ,trigger: 'change', validator: this.validateNumber}]
      }
    };
  },
  created(){
  },
  mounted() {

  },
  methods: {
    validateNumber(rule, value, callback) {
      const pattern = /^\d+$/
      if (!pattern.test(value)) {
        callback(new Error('请输入正确数字'));
      }
      callback();
    },
    clear() {

    },
    close() {
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
    cancel(){

    },
    save() {
      this.$refs['form'].validate( bool => {
        if(bool){
            const param = {
              ...this.formData
            }
            provideAssets(param).then( res=> {
              this.$Message.success('保存成功');
              this.changeLoading()
              this.$emit('done')
              this.isShow=false
            }).catch( () => {
              this.changeLoading()
              return
            })
        }else{
          this.changeLoading()
          return
        }
      })

    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    findAssets(){
      console.log(this.formData.assetsCode)
      getAssetsByAccetsCode(
          {
            assetsCode:this.formData.assetsCode
          }
      ).then(res => {
        if (!res.data) {
          return
        }
        this.formData.assetsName = res.data.assetsName
      }).catch(() => {
        return
      })
    },

    remoteMethod(query){
      if (query !== '') {
        this.loading = true;
        let params = {
          assetsCode:query
        }
        // console.log(query)
        getLikeCodeByAccetsCode(params).then(res => {
          this.loading = false;
          this.assetsCodeList = res.data;
        }).catch(() => {
          return
        })
      } else {
        this.assetsCodeList = [];
        this.formData.assetsCode = ''
      }
    },

    remoteFindPersonMethod(query){
      if (query !== '') {
        this.loading = true;
        let params = {
          name:query
        }
        getPersonNameByName(params).then(res => {
          this.loading = false;
          this.receivePersonNameList = res.data;
        }).catch(() => {
          return
        })
      } else {
        this.receivePersonNameList = [];
        this.formData.receivePersonName = ''
      }
    }
  },
};
</script>

<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
}
.content-box {
  flex: 1;
  display: flex;
  position: relative;
  .content-l {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
  }
  #grouplist {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .content-r {
    flex: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li {
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
        &:last-child {
          border-bottom: none;
        }
        p {
          height: 30px;
          line-height: 30px;
          .r-name {
            font-weight: bold;
            color: green;
            cursor: pointer;
            display: inline-block;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.model-new{
  height:600px;
}
#container {
  /deep/ .amap-info-content {
    padding: 0;
    background: #fff;
    min-width: 250px;
  }
  /deep/ .amap-info-close {
    right: 0 !important;
    top: 3px;
  }
  /deep/ .info-content {
    padding: 10px;
    p {
      line-height: 25px;
      height: 25px;
      padding: 5px;
      color: #333;
      word-break: break-all;
      width: 200px;
    }
    margin-bottom: 10px;
  }
}
</style>
